module.exports = __webpack_public_path__ + "static/media/secure.9e81a9e5.gif";